import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import classNames from 'classnames';

import { FieldBehaviorMode } from '@app/queryTyping';

import { Field, FieldComponent, FieldLocator } from '@app/common/configurable-wizards/types';
import { DEFAULT_COUNTRY } from '@app/common/types/locales';

import { COUNTRY_FIELD_NAME } from '@app/widgets/contacts-and-settings/contexts/AddressFormContext';
import {
  ConditionalField,
  ConditionalFieldContext,
  InternationalAddressFields,
  USAddressFields,
} from '@app/widgets/contacts-and-settings/types';

import styles from './ConditionalAddressField.pcss';

export const ConditionalAddressFieldComponent: FieldComponent<Field> = ({
  parent,
  field,
  locator,
}) => {
  const { getValues } = useFormContext();
  const currentCountry = useWatch({ name: `${parent}.${COUNTRY_FIELD_NAME}` })
    || getValues()?.[parent]?.[COUNTRY_FIELD_NAME]
    || DEFAULT_COUNTRY;
  const isHiddenField = currentCountry === DEFAULT_COUNTRY
    ? field.id in InternationalAddressFields
    : field.id in USAddressFields;

  const Component = locator({
    ...field,
    skipConditionalField: true,
  } as ConditionalField);

  return (
    <div className={classNames(isHiddenField && styles.hidden)}>
      <Component
        locator={locator}
        parent={parent}
        field={
          isHiddenField
            ? { ...field, fieldBehaviorMode: FieldBehaviorMode.OPTIONAL } as Field
            : field
        }
      />
    </div>
  );
};

export const ConditionalAddressFieldLocator: FieldLocator = ({ field }: ConditionalFieldContext) => (
  !field.skipConditionalField && field.id in { ...USAddressFields, ...InternationalAddressFields }
    ? ConditionalAddressFieldComponent
    : undefined
);
